import { useCollectionsNews } from "./hooks/useCollectionsNews";
import {
  ContainerListCollection,
  ListCollection,
  AddNameCollection,
  BtnCollection,
  BorderColor,
  FoodNewCollection,
  FoodCardAdd,
  FoodCardRemove,
  BtnGroupPagination,
	FlipContainer,
  FoodCardSaved
} from "./styles";
import ContentIcon from "@/shared/ContentIcon";
import CollectionSaveExit from "./components/CollectionSaveExit";
import BtnNewCollection from "./components/BtnNewCollection";
import BtnGroupCollection from "./components/BtnGroupCollection";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const SaveCollectionsNews = ({
  noteDetail,
  list = false,
  classCustom = "",
}) => {

  const dataContext = useContext(TemplateContext);
  const { handleCollections, savedNoteStatus, setSavedNoteStatus } = dataContext || {};

  const {
    btnSaveNews,
    formSaveNews,
    collectionsDisplay,
    currentPageCollection,
    totalPagesCollection,
    handleCollectionsDisplay,
    disabledTypeNews,
    formStateCollection,
    noteSaved,
    onFormSubmit,
    onFormSubmitCollection,
    onInputChangeCollection,
    openForm,
    openFormCollection,
    openFormDel,
    onBtnAddNews,
    onBtnAddNewsCancel,
    onBtnAddCollectionCancel,
    onBtnCloseModalSuccess,
    onBtnDel,
    onBtnDelCancel,
    onBtnProcess,
    setDisplay,
    setClassBtnProcess,
    openModalSuccessMessage = true
  } = useCollectionsNews(noteDetail, handleCollections, savedNoteStatus, setSavedNoteStatus);

  return (
    <>
      {!disabledTypeNews && (
        <div className={classCustom}>
          <FlipContainer isOpen={openForm || openFormCollection} className="flip-container">
            <FoodCardAdd
              onClose={onBtnAddNewsCancel}
              iconClose={false}
              id="food-card-add"
              className={openForm ? "isOpen" : ""}
            >
              {/* TODO: agregar CollectionSaveExit, mesaje de guardado con exito antes de cerrar el listado */}
              <CollectionSaveExit onClick={onBtnAddNewsCancel} />

              <div className="titleCard m-right-auto">
                AGREGALA A UNA COLECCIÓN
              </div>
              <BorderColor />
              <form onSubmit={onFormSubmit} ref={formSaveNews}>
                <ContainerListCollection className="container-list-collection">
                  {collectionsDisplay?.map((collection, index) => {
                    return (
                      <ListCollection key={`collection${index}`} className="list-collection">
                        <input
                          type="radio"
                          name="collectionName"
                          value={collection}
                        />
                        <label>{collection}</label>
                      </ListCollection>
                    );
                  })}
                </ContainerListCollection>
                {/* TODO: agregar BtnGroupPagination paginacion de 5 en 5, visualizar solo cuando la lista supere los 5 items en colección */}
                <BtnGroupPagination>
                  <button
                    type="button"
                    className="btnPrev"
                    onClick={() =>
                      handleCollectionsDisplay(currentPageCollection - 1)
                    }
                  >
                    <ContentIcon
                      width="18px"
                      height="18px"
                      nameIcon="circle-chevron-left"
                    />
                  </button>
                  <span className="textPagination">
                    {" "}
                    {currentPageCollection} de {totalPagesCollection}{" "}
                  </span>
                  <button
                    type="button"
                    className="btnNext"
                    onClick={() =>
                      handleCollectionsDisplay(currentPageCollection + 1)
                    }
                  >
                    <ContentIcon
                      width="18px"
                      height="18px"
                      nameIcon="circle-chevron-right"
                    />
                  </button>
                </BtnGroupPagination>
                <BorderColor />
                <BtnNewCollection onClick={onBtnAddNews}></BtnNewCollection>
                <BtnGroupCollection
                  onCancel={onBtnAddNewsCancel}
                ></BtnGroupCollection>
              </form>
            </FoodCardAdd>

            <FoodNewCollection
              onClose={onBtnAddCollectionCancel}
              iconClose={false}
              className={openFormCollection ? "isOpen" : ""}
              id="food-new-collection"
            >
              <div className="titleCard">CREAR COLECCIÓN</div>
              <form onSubmit={onFormSubmitCollection}>
                <AddNameCollection>
                  {/* <label>Nombre de la colección</label> */}
                  <input
                    type="text"
                    name="collectionName"
                    placeholder="Escribir nombre"
                    value={formStateCollection.collectionName}
                    onChange={onInputChangeCollection}
                    autoComplete="off"
                    className="collection-name"
                  />
                </AddNameCollection>
                <BtnGroupCollection
                  onCancel={onBtnAddCollectionCancel}
                ></BtnGroupCollection>
              </form>
            </FoodNewCollection>
          </FlipContainer>
            
          <FlipContainer isOpen={openFormDel} className="flip-container">
          <FoodCardRemove
            style={{ display: setDisplay("remove") }}
            className={openFormDel ? "isOpen" : ""}
             id="food-card-remove"
          >
            <div onClose={onBtnDelCancel} height="250px">
              <div className="titleCard-delete">
                <p>¿Estás seguro de querer eliminar esta receta?</p>
              </div>
              <BtnGroupCollection
                onCancel={onBtnDelCancel}
                onOk={onBtnDel}
                okText="Eliminar"
              ></BtnGroupCollection>
            </div>
          </FoodCardRemove>
          </FlipContainer>
          <BtnCollection
            className={`${setClassBtnProcess()} btnCircle`}
            ref={btnSaveNews}
            //disabled={!noteSaved.status}
            aria-label="Guardar nota"
            data-red="Guardar nota"
            onClick={onBtnProcess}
          >
            {noteSaved.noteActive.cmd === "add" ? (
              <>
                <ContentIcon
                  width="16px"
                  height="22px"
                  nameIcon="bookmark-regular"
                />
								<input id={"add-recipe-" + noteDetail._id} type="checkbox" hidden readOnly checked={openForm || openFormCollection} />
              </>
            ) : (
              <div className="btn-deleted">
                <ContentIcon
                  width="23px"
                  height="23px"
                  nameIcon="bookmark-solid"
                />
								<input id={"add-recipe-" + noteDetail._id} type="checkbox" hidden readOnly checked={openFormDel} />
              </div>
            )}
          </BtnCollection>

          <FlipContainer isOpen={openModalSuccessMessage} className="flip-container">
          <FoodCardSaved
            onClose={onBtnAddNewsCancel}
            iconClose={true}
            className={openModalSuccessMessage ? "isOpen" : ""}
             id="food-card-saved"
          >
            <button type="button" onClick={onBtnCloseModalSuccess}>
                <ContentIcon width= "18px" height="18px" nameIcon='closeIco'/>
            </button>
            <div>
              <div className="titleCard-message">
                <p>La receta se agregó a tus recetas guardadas.</p>
              </div>
            </div>
          </FoodCardSaved>
          </FlipContainer>
        </div>
      )}
    </>
  );
};

export default SaveCollectionsNews;
